export default __webpack_public_path__ + "static/banner_2-0dad360fcb23d0af3867560bdee9b1a9.jpg";